import { render, staticRenderFns } from "./AdvertPage.vue?vue&type=template&id=3a82d806&scoped=true&lang=pug&"
import script from "./AdvertPage.vue?vue&type=script&lang=js&"
export * from "./AdvertPage.vue?vue&type=script&lang=js&"
import style0 from "./AdvertPage.vue?vue&type=style&index=0&id=3a82d806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a82d806",
  null
  
)

export default component.exports